import Vue from 'vue'
import { _filters } from './index';


Object.keys(_filters).forEach(
  name => {
    Vue.filter(name , _filters[name])
  }
)
